import React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "../../components/Button/Button";
import "./Detail.css";

export default function Detail() {
  const [country, setCountry] = useState([]);
  const { numericCode } = useParams();

  useEffect(() => {
    console.error(`${numericCode}`);
    const getSingleCountry = async () => {
      try {
        const res = await fetch(
          `https://restcountries.com/v3.1/alpha?codes=${numericCode}`
        );
        const data = await res.json();
        setCountry(data);
      } catch (error) {
        console.error(error);
      }
    };

    getSingleCountry();
  }, [numericCode]);

  return (
    <div>
      <section className="container-detail">
        {country.map((item) => (
          <div key={item.name}>
            <article className="image-flag-detail">
              <img
                src={item.flags.svg}
                width={250}
                height={250}
                alt={item.name.common}
              />
            </article>
            <article className="info-country">
              <h1>{item.name.official}</h1>
              <ul>
                <li>Capital: {item.capital[0]}</li>
                <li>Population: {item.population.toLocaleString()}</li>
                <li>Region: {item.region}</li>
                <li>Subregion: {item.subregion}</li>
              </ul>
              {item.borders && (
                <>
                  <h3>Borders:</h3>
                  <ul>
                    {item.borders.map((border, index) => (
                      <li key={index} className="borders_stack">
                        {border}
                      </li>
                    ))}
                  </ul>
                </>
              )}

              <a href="/country">
                <Button label={"Back"} />
              </a>
            </article>
          </div>
        ))}
      </section>
    </div>
  );
}
